export interface IForgotPasswordResponse {
    data: {
        success: boolean,
        message: string
    }
};